import(/* webpackMode: "eager" */ "/alias/app/globals.css");
import(/* webpackMode: "eager" */ "/alias/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/alias/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/alias/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/alias/components/ui/tooltip.tsx")